import React from 'react';
import PropTypes from 'prop-types';
import FormControl from './Controls/FormControl';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';

export default class SearchField extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    children: PropTypes.element,
    className:  PropTypes.string,
    labelClassName:  PropTypes.string,
    inputClassName:  PropTypes.string,
    caption: PropTypes.string,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    dataValue: PropTypes.any,
    onValueChange: PropTypes.func
  };

  constructor(props){
    super(props);
    this.renderField = this.renderField.bind(this);
  }

  renderField(){
    if (this.props.children){
      return React.cloneElement(React.Children.only(this.props.children), {
        placeholder: this.props.placeholder,
        onValueChange: this.props.onValueChange,
        dataValue: this.props.dataValue,
        name: this.props.name
      });
    } else {
      return <FormControl name={this.props.name} placeholder={this.props.placeholder} onValueChange={this.props.onValueChange}
        type={this.props.type} className={this.props.inputClassName} />;
    }
  }

  render() {
    return (
      <FormGroup controlId={this.props.name} key={this.props.name} className={this.props.className}>
        {this.props.caption ? <ControlLabel className={this.props.labelClassName}>{this.props.caption}</ControlLabel> : null}
        {this.renderField()}
      </FormGroup>);
  }
}
